<div class="toast toast-{{toast.type}}"
     [style.top.px]="i*140">
  <app-typography variant="heading-title" class="toast-heading">{{ toast.title }}</app-typography>
  <app-typography variant="body-b2" class="toast-body">{{ toast.body }}</app-typography>
  <a class="close" (click)="remove.emit(i)">&times;</a>
</div>
